module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0109.jpg?v=87e4fd17";